<script>
import ImageItem from '@components/image-item'
import PhotoGallery2 from '@components/photo-gallery-2.vue'
import {lazyLoadOptions} from '@constants'
import {useApplicationStore} from '@stores/application.store'

export default {
  name: 'ImageItems',

  components: {
    ImageItem,
    PhotoGallery2,
  },

  props: {
    items: {
      type: Array,
      required: true,
      default: () => ([]),
    },

    lazy: {
      type: Boolean,
      default: false,
      required: false,
    },

    // imageLayout
    imageLayout: {
      type: String,
      default: 'normal',
      required: false,
    },

    // imageDescStyle
    imageDescStyle: {
      type: String,
      default: 'normal',
      required: false,
    },
  },

  data: () => ({
    lazyLoadOptions,
    photoGalleryShouldBeVisible: false,
    targetOfImageGallery: null,
  }),

  computed: {
    // use to preview images
    // either in PhotoGallery.vue or in wx.previewImage of wechat
    pictures () {
      if (this.items && this.items.length) {
        if (this.items[0].src) {
          return this.items.map(item => item.src)
        }
        else {
          return this.items
        }
      }
      else {
        return []
      }
    },
  },

  methods: {
    // imageItemDidPress
    // - 2023.08.09
    // - Replace image preview with new component PhotoGallery2
    async imageItemDidPress ({item}) {
      const applicationStore = useApplicationStore()
      const target = item && item.src ? item.src : item

      if (applicationStore.wechat || applicationStore.wework) {
        const targetWithSuffix = `${target}!/fw/2800/rotate/auto/format/webp`
        const picturesWithSuffix = this.pictures.map(pic => `${pic}!/fw/2800/rotate/auto/format/webp`)

        wx.previewImage({
          current: targetWithSuffix,
          urls: picturesWithSuffix,
        })
      }
      else if (applicationStore.douyin) {
        tt.miniProgram.previewImage({
          current: target,
          urls: this.pictures,
        })
      }
      else {
        this.targetOfImageGallery = target
        this.photoGalleryShouldBeVisible = true
      }
    },
  },
}
</script>

<template>
  <div class="image-items-wrapper">
    <template v-if="pictures && pictures.length">
      <photo-gallery-2
        v-model:visible="photoGalleryShouldBeVisible"
        :target="targetOfImageGallery"
        :images="pictures" />
    </template>

    <template v-if="lazy">
      <div
        v-lazy-container
        class="image-items">
        <template
          v-for="(item, itemIndex) in items"
          :key="itemIndex">
          <image-item
            :item="item"
            :lazy="lazy"
            :image-layout="imageLayout"
            :image-desc-style="imageDescStyle"
            @image-item-did-press="imageItemDidPress" />
        </template>
      </div>
    </template>
    <template v-else>
      <div class="image-items">
        <template
          v-for="(item, itemIndex) in items"
          :key="itemIndex">
          <image-item
            :item="item"
            :lazy="lazy"
            :image-layout="imageLayout"
            :image-desc-style="imageDescStyle"
            @image-item-did-press="imageItemDidPress" />
        </template>
      </div>
    </template>
  </div>
</template>

<style lang='scss' scoped>
</style>
